module.exports = __webpack_public_path__ + "img/localInfo.c6c039b8.png";